export enum TrainingLength {
  LessThanOneHour = 'Less than 1 hour',
  OneToFourHours = '1 - 4 hours',
  FourToEightPlusHours = '4 - 8+ hours'
}
